import { render, staticRenderFns } from "./PatentOfficialDeadlineLogForm.vue?vue&type=template&id=37c5962c&"
import script from "./PatentOfficialDeadlineLogForm.vue?vue&type=script&lang=js&"
export * from "./PatentOfficialDeadlineLogForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentOfficialDeadlineLogForm.vue?vue&type=style&index=0&id=37c5962c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports